import Model, { ID, Integer, IsoDateTime } from 'src/models/model'
import Librariable from 'src/models/model/concerns/Librariable'

export default class EmployeeJobType extends Model {
  static name = 'EmployeeJobType'

  static deletable = true
  static versioned = true
  static paginate = true
  static duplicatable = true
  static isConfiguration = true

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Team]

  static define () {
    this.concerns = [Librariable]

    this.fields = {
      id: {
        type: ID,
        required: true,
        sortable: true
      },
      name: {
        type: String,
        required: true,
        sortable: true
      },
      hourlyRate: {
        type: Number,
        required: true,
        sortable: true
      },
      displayOrder: {
        type: Integer,
        required: true,
        default: 100
      },
      siteId: {
        type: ID,
        required: true,
        output: true
      },
      createdAt: {
        type: IsoDateTime,
        sortable: true,
        output: true
      },
      updatedAt: {
        type: IsoDateTime,
        sortable: true,
        output: true
      }
    }
  }
}
